import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import { useAppSelector } from "../../app/store/configureStore";
import { AnswersProps } from "../../app/models/Answers";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  first: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
  second: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});

const CognitiveDevelopment: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const { user } = useAppSelector((state) => state.account);

  const isHomeVisitor = user?.credentialTypeId === 4;
  const firstSystemCodeId = isHomeVisitor ? 55 : 53;
  const secondSystemCodeId = isHomeVisitor ? 56 : 54;

  const defaultValues = {
    first: answersData.find(
      (answer) => answer.systemCodeId === firstSystemCodeId
    )?.answer,
    second: answersData.find(
      (answer) => answer.systemCodeId === secondSystemCodeId
    )?.answer,
  };

  const {
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  return (
    <Grid pb={3}>
      <Grid item xs={12} px={3} pt={3}>
        <Typography variant="body1" fontWeight="bold" paragraph>
          CS II-b - Cognitive Development Learning Experience
        </Typography>
        <Typography variant="body1" paragraph>
          {user?.credentialTypeId !== 4
            ? "Pick another of the nine learning experiences (activities) from your Resource Collection II that reflects your philosophy about supporting young children's intellectual or cognitive development."
            : "Pick another learning experience/activity from your Resource Collection II that reflects your philosophy of how to support families of young children in promoting their children's curiosity and discovery?"}
        </Typography>
      </Grid>
      <Grid item xs={12} px={3} pt={3}>
        <TextField
          label={
            user?.credentialTypeId !== 4
              ? "The learning experience that reflects my philosophy about supporting young children's cognitive development is"
              : "The learning experience that reflects my philosophy of how to support families of young children in promoting their curiosity and discovery is"
          }
          multiline
          rows={2}
          fullWidth
          {...register("first")}
          name="first"
          value={
            answersData.find(
              (answer) => answer.systemCodeId === firstSystemCodeId
            )?.answer || ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = firstSystemCodeId;

            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.first?.message}
          helperText={errors.first?.message}
        />
        <Typography fontSize={13}>{defaultValues.first?.length}/500</Typography>
      </Grid>
      <Grid item xs={12} px={3} pt={3}>
        <Typography variant="body1" paragraph>
          {user?.credentialTypeId !== 4
            ? "How does this learning experience reflect your philosophy about supporting young children's cognitive development?"
            : "How does this learning experience reflect your philosophy about supporting families of young children in promoting their children curiosity and discovery?"}
        </Typography>
      </Grid>
      <Grid item xs={12} px={3} pt={3}>
        <TextField
          label={
            user?.credentialTypeId !== 4
              ? "This learning experience reflects my philosophy about cognitive development because"
              : "This learning experience reflects my philosophy about supporting families of young children in promoting their children curiosity and discovery because"
          }
          multiline
          rows={2}
          fullWidth
          {...register("second")}
          name="second"
          value={
            answersData.find(
              (answer) => answer.systemCodeId === secondSystemCodeId
            )?.answer || ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = secondSystemCodeId;
            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.second?.message}
          helperText={errors.second?.message}
        />
        <Typography fontSize={13}>
          {defaultValues.second?.length}/500
        </Typography>
      </Grid>
    </Grid>
  );
};
export default CognitiveDevelopment;
